/**
 * Format a number to the euro currency standards
 * @param {number} n The number to format
 * @returns {string} The formatted number
 */
export const formatToEuro = function (n) {
  return '€' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
